import { Action } from "common/types";

import actionTypes from "../action-types";
import DropdownsState from "../models/DropdownsState";

export default function dropdownsReducer(
  state: DropdownsState = new DropdownsState(),
  action: Action<Record<string, any>>
) {
  switch (action.type) {
    case actionTypes.INITIALISE_SELECTED_CHILD:
      return state.merge({
        childUserIdInitialised: true,
        childUserId: action.payload!.userId
      });

    case actionTypes.SET_CHILD_USER_ID:
      return state.set("childUserId", action.payload!.userId);

    case actionTypes.SET_START_TIME:
      return state.merge({
        startTime: action.payload!.startTime,
        isCustomPeriod: true
      });

    case actionTypes.SET_END_TIME:
      return state.merge({
        endTime: action.payload!.endTime,
        isCustomPeriod: true
      });

    case actionTypes.SET_TIME_PERIOD:
      return state.merge({
        startTime: action.payload!.startTime,
        endTime: action.payload!.endTime,
        isCustomPeriod: false
      });

    default:
      return state;
  }
}
